module.exports = __webpack_public_path__ + "static/media/alicebanner_sm3.c4840841.png";